import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const INITIAL_STATE = {
    isIframe: false,
    dealerId: '',
    categoryId: '',
};
export const reducer = createReducer(INITIAL_STATE, (builder) => {
    builder
        .addCase(actions.isIframe, (state, { payload }) => ({
        ...state,
        isIframe: payload,
    }))
        .addCase(actions.testRideDealerId, (state, { payload }) => ({
        ...state,
        dealerId: payload,
    }))
        .addCase(actions.categoryId, (state, { payload }) => ({
        ...state,
        categoryId: payload,
    }));
});
